import { useCallback } from 'react';
import { Field } from 'react-final-form';
import { UniversalForm } from '@rainbow-modules/forms';
import Button from 'components/Button';
import WorkflowPicker from 'components/WorkflowPicker';
import { validateNotEmpty } from 'data/validators';
import { Container, Content, Footer } from './styled';

interface FormValues {
    workflowId: string;
}

interface Props {
    agentId?: string;
    initialValues?: Record<string, unknown>;
    onRequestClose?: () => void;
    onSubmit?: (values: FormValues) => Promise<void>;
}

const FORM_ID = 'edit-sip-domain-form';

const EditDomainForm = ({
    agentId = '',
    initialValues,
    onRequestClose = () => {},
    onSubmit,
}: Props) => {
    const handleSubmit = useCallback(
        async (values: Record<string, unknown>) => {
            if (onSubmit) await onSubmit(values as unknown as FormValues);
        },
        [onSubmit],
    );

    return (
        <Container>
            <Content>
                <UniversalForm id={FORM_ID} onSubmit={handleSubmit} initialValues={initialValues}>
                    <Field
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore
                        component={WorkflowPicker}
                        name="workflowId"
                        label="Workflow"
                        labelAlignment="left"
                        required
                        validate={validateNotEmpty('This field is required')}
                        agentId={agentId}
                    />
                </UniversalForm>
            </Content>
            <Footer>
                <Button
                    label="Cancel"
                    variant="outline-brand"
                    borderRadius="semi-square"
                    className="rainbow-m-right_medium"
                    onClick={onRequestClose}
                />
                <Button
                    label="Save"
                    variant="brand"
                    form={FORM_ID}
                    type="submit"
                    borderRadius="semi-square"
                />
            </Footer>
        </Container>
    );
};

export default EditDomainForm;
